// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import useRouter from '../../../hooks/useRouter';
import RoutesRedirectionFactory from '../../../utils/routes/RoutesRedirectionFactory';
import KLOrientationStep from '../components/KLOrientationStep';
import selectKLOrientationStepProps from '../selectors/specifics/selectKLOrientationStepProps';
import { ObfKLCollectibleIds, type KLCollectibleId } from '../types/collectible';

type KLOrientationStepContainerProps = {
  className?: string;
  stepId: KLCollectibleId;
  paginationIndex: number;
  disableInteraction?: boolean;
};

const KLOrientationStepContainer = (props: KLOrientationStepContainerProps) => {
  const { disableInteraction = false, ...ownProps } = props;
  const { stepId, paginationIndex } = ownProps;
  const { history } = useRouter();

  const selectedProps = useSelector((state) => selectKLOrientationStepProps(state, { stepId, paginationIndex }));

  const onClick = useCallback(() => {
    if (!disableInteraction) {
      history.push(
        RoutesRedirectionFactory.getKLOrientationStepDetailsRouteConfig(paginationIndex, ObfKLCollectibleIds[stepId]),
      );
    }
  }, [disableInteraction, history, paginationIndex, stepId]);

  const actionsProps = useMemo(
    () => ({
      onClick,
    }),
    [onClick],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, actionsProps });
  return <KLOrientationStep {...enhancedProps} />;
};

export default KLOrientationStepContainer;
